module.exports = __webpack_public_path__ + "static/media/sotu_2x.7c44f904.webp";